export const Status = {
  Ready: "ready",
  In_progress: "in_progress",
  Confirm: "confirm",
  Confirm_error: "confirm_error",
  Partly_paid: "partly_paid",
  Paid: "paid",
};

export const StatusDictionary = {
  [Status.Ready]: "Μη Βεβαιωμένη",
  [Status.In_progress]: "Σε Διαδικασία Βεβαίωσης",
  [Status.Confirm]: "Βεβαιωμένη",
  [Status.Paid]: "Πλήρως Εξοφλημένη",
  [Status.Partly_paid]: "Μερικώς Εξοφλημένη",
  [Status.Confirm_error]: "Προβληματική",
};

export const MoneyListTypeDict = {
  Gemi: "Γ.Ε.ΜΗ.",
  Chamber: "Επιμελητήριο",
};

export const MoneyListType = {
  Gemi: "gemi",
  Chamber: "chamber",
};
